module.exports = __webpack_public_path__ + "img/white_logo.c7fb4b1d.png";